export default "__VITE_ASSET__if53VHkW__"